import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    addContainer: {
      backgroundColor: '#F5F7F9',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      textTransform: 'uppercase',
      borderBottom: '1px solid #E4E8ED',
      padding: '16px 16px 10px 16px',
    },
    title: {
      fontSize: 14,
      fontWeight: 600,
      color: colorVariables.grey60,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 12,
      },
    },
    addMethod: {
      fontSize: 14,
      fontWeight: 700,
      color: colorVariables.navy,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'relative',
      '& svg': {
        position: 'absolute',
        left: -24,
        top: -2,
        color: '#52DAB1',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 12,
      },
    },
    noPayment: {
      textAlign: 'center',
      fontSize: 14,
      marginTop: 24,
    },
    paymentContainer: {
      
    },
    paymentTitle: {
      textTransform: 'capitalize',
    },
    paymentSubTitle: {

    },
    backContainer: {
      fontSize: 14,
      fontWeight: 600,
      color: colorVariables.navy,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
    },
    backChevron: {
      fontSize: 18,
      fontWeight: 600,
      marginRight: 8,
      color: colorVariables.navy,
    },
  }),
);
